var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15129 3.8173C6.72822 4.24037 6.72822 4.9263 7.15129 5.34937L11.8019 10L7.15129 14.6506C6.72822 15.0737 6.72822 15.7596 7.15129 16.1827C7.57435 16.6058 8.26028 16.6058 8.68335 16.1827L14.1 10.766C14.5231 10.343 14.5231 9.65704 14.1 9.23397L8.68335 3.8173C8.26028 3.39423 7.57435 3.39423 7.15129 3.8173Z",
    fill: "#448181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.d0632d545ee2658e1925673addf88f7e.svg";
export { ForwardRef as ReactComponent };